import { render, staticRenderFns } from "./MarketingEmailEditVerify.vue?vue&type=template&id=d2c82818&scoped=true"
import script from "./MarketingEmailEditVerify.vue?vue&type=script&lang=js"
export * from "./MarketingEmailEditVerify.vue?vue&type=script&lang=js"
import style0 from "./MarketingEmailEditVerify.vue?vue&type=style&index=0&id=d2c82818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c82818",
  null
  
)

export default component.exports